    <div class="">
        <div class="toolbar">
            <!-- Browse Button -->
            <button mat-flat-button color="primary" i18n>Choose File</button>
            <!-- Display files names -->
            <input matInput [(ngModel)]="fileAttr" readonly name="name" />
        </div>
        <!-- Fetch selected filed on change -->
        <input type="file"
               #fileInput
               id="uploadFile"
               (change)="onFileChange($event)"
               name="uploadFile"
               multiple="multiple"
               [accept]="accept" />
    </div>
    <div>
        {{message}}
    </div>
